import React, { Component } from "react";
import Layout from "./../../Layout";
export default class Notification extends Component {
	render() {
		return <Layout {...this.props} noSidebar classFromChildren={'no-sidebar has-padding'}>
			<h1>Not Found</h1>
		</Layout>;
	}
}